import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';
import { IoAddCircleOutline, IoStar, IoStarOutline } from 'react-icons/io5';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './Products.css'
import ProductCard from '../ProductCard/ProductCard';
import SecureLS from "secure-ls";

function RelatedProducts({productCollection}) {
    const ls = new SecureLS({ encodingType: 'aes' });
    const productsSettings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        adaptiveHeight: false,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const [products, setProducts] = useState([])
    const baseUrl = 'https://karstar.in/'
    const [loading, setLoading] = useState(true); // Add a loading state

    useEffect(() => {
        setLoading(true);
        const sessionId = sessionStorage.getItem('sessionId');
        const username = ls.get('userEmail');
        if (username) {
            getRelatedProducts('na', username);
        } else {
            getRelatedProducts(sessionId || 'na', 'na');
        }
    }, [productCollection]);

    const getRelatedProducts = async (sessionId, username) => {
        try {
            const response = await axios.get(`https://karstar.in/api/client_api/RelatedProducts/index.php?category=${productCollection}&ipadd=${sessionId}&email=${username}`);
            setProducts(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false); // Set loading to false after the fetch is complete
        }
    };


    return (
        <div>
            <Container>
                <section className='pt-5' >
                    <Row className="g-0">
                        <Col>
                            <h4 className='title py-2'>More products in {productCollection}</h4>
                            {loading ? (
                                <div>Loading...</div> // Display a loading message or spinner
                            ) : (
                                <Slider {...productsSettings} className="top-categories pt-2">
                                    {products.map((item, index) => (
                                        <ProductCard key={index} item={item} baseUrl={baseUrl} wishlist={item.in_wishlist} cart={item.in_cart} analyticsContext="related_products" />
                                    ))}
                                </Slider>
                            )}
                        </Col>
                    </Row>
                </section>
            </Container>
        </div>
    )
}

export default RelatedProducts
